export const magniteS2sConfig = {
  enabled: true,
  accountId: "7450",
  bidders: ["mgnipbs"],
  defaultVendor: "rubicon",
  coopSync: true,
  userSyncLimit: 8,
  defaultTTL: 300,
  timeout: 500,
  allowUnknownBidderCodes: true,
  extPrebid: {
    cache: {
      vastxml: { returnCreative: false },
    },
    bidders: {
      mgnipbs: {
        wrappername: "7450_Web_Server",
      },
    },
  },
};
